export enum UserType {
    ADMIN, COURT
}
